// ? When adding columns, remember to update model on the backend.
// ? especially the filterSchema.

import { dateOf } from '@/lib/time';
import { GetAgreementCategories } from '@/lib/API';

export default {
	columns : {
		agreementsKey : {
			title  : 'GIS Ref. #',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 0,
		},

		dateRecorded : {
			title         : 'Date Recorded',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 1,
			transformText : dateOf,
		},

		recordNumber : {
			title  : 'Record #',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 2,
		},

		vaultReference : {
			title  : 'Map Ref. #',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 3,
		},

		facilities : {
			title         : 'Facility',
			sort          : 'string',
			filter        : 'string',
			hidden        : false,
			order         : 4,
			filterColumn  : 'facilities.[name,number]',
			key           : 'facilities',
			transformText : a => a.reduce( ( allFacilities, facility, index ) => {

				const formattedFacilityText = `${facility.name} No. ${facility.number}`;
				const facilityList          = `${allFacilities}${formattedFacilityText}`;

				if ( index === a.length - 1 ) {
					return facilityList;
				}

				return `${facilityList}<br>`;

			}, '' ),
		},

		mappedInGis : {
			title         : 'Mapped In GIS',
			filter        : 'boolean',
			hidden        : false,
			order         : 5,
			transformText : a => ( a ? 'Yes' : 'No' ),
		},

		agreementCategoryDescription : {
			title        : 'Category',
			sort         : 'string',
			filter       : 'dropdown',
			index        : true,
			weight       : 10,
			order        : 6,
			filterColumn : 'agreementCategory.description',
			headerClass  : 'agreement-type',
		},

		type : {
			title  : 'Type',
			sort   : 'string',
			filter : 'string',
			index  : true,
			weight : 10,
			order  : 7,
		},

		recordOwner : {
			title  : 'Record Owner',
			sort   : 'string',
			filter : 'string',
			index  : true,
			weight : 10,
			hidden : false,
			order  : 8,
		},

		locationDescription : {
			title        : 'Cross Streets',
			sort         : 'string',
			filter       : 'string',
			hidden       : false,
			order        : 9,
			filterColumn : 'location.description',
		},

		t : {
			title  : 'Township',
			sort   : 'number',
			filter : 'string',
			index  : false,
			hidden : false,
			order  : 10,
		},

		r : {
			title  : 'Range',
			sort   : 'number',
			filter : 'string',
			index  : false,
			hidden : false,
			order  : 11,
		},

		s : {
			title  : 'Section',
			sort   : 'number',
			filter : 'string',
			index  : false,
			hidden : false,
			order  : 12,
		},

		q : {
			title  : 'Qtr',
			sort   : 'string',
			filter : 'string',
			index  : false,
			hidden : false,
			order  : 13,
		},

		wasteWater : {
			title         : 'Waste Water',
			filter        : 'boolean',
			hidden        : false,
			order         : 14,
			transformText : a => ( a ? 'Yes' : 'No' ),
		},

	},

	dropdownOptions : {
		agreementCategoryDescription : {
			defaultText : 'Select Agreement Category',
			options     : GetAgreementCategories,
		},
	}
};
